import { render } from "./ColocationDetails.vue?vue&type=template&id=78cfc8b2"
import script from "./ColocationDetails.vue?vue&type=script&lang=js"
export * from "./ColocationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__